// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Caml_option from "../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as EventTracker from "../../../../../../../../library/event-tracker/react-ga/EventTracker.bs.js";
import * as ProgressModal from "../../../../../../../../library/components/generic-components/components/ProgressModal.bs.js";
import * as CityVehicleCmp from "../reusable-components/CityVehicleCmp.bs.js";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as SidebarHeaderCmp from "../reusable-components/SidebarHeaderCmp.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as AllocationFilterWrapper from "../../../allocation-dashboard-home/allocation-filters/AllocationFilterWrapper.bs.js";
import * as AllocationCampaignAction from "../../../allocation-dashboard-home/table-component/AllocationCampaignAction.bs.js";
import * as FilterAllocationTableTab from "../../../allocation-dashboard-home/table-component/FilterAllocationTableTab.bs.js";
import * as AllocationCampaignFooterCmp from "../reusable-components/AllocationCampaignFooterCmp.bs.js";
import * as AllocationDashboardDataMachine from "../../../../../app/repo/AllocationDashboardDataMachine.bs.js";
import * as MandatoryAllocationCampaignsCmp from "../create-campaign/campaign-details/MandatoryAllocationCampaignsCmp.bs.js";

function ViewCampaign(Props) {
  var campaign = Props.campaign;
  var user_role = Props.user_role;
  var campaigns_list = Props.campaigns_list;
  var dispatch = Props.dispatch;
  var match = React.useState(function () {
        return /* Init */0;
      });
  var setRequestStatus = match[1];
  var requestStatus = match[0];
  var match$1 = CountryContext.useContext(undefined);
  var country = match$1.country;
  var active_campaign = Belt_List.getExn(List.filter(function (campaign) {
              return campaign.campaign_status === /* Active */0;
            })(campaigns_list.campaigns), 0);
  var updateCampaign = function (campaign_action) {
    Curry._1(setRequestStatus, (function (param) {
            return {
                    TAG: /* Loading */0,
                    _0: undefined
                  };
          }));
    return AllocationDashboardDataMachine.updateMandatoryCampaign({
                action: AllocationCampaignAction.toString(campaign_action),
                campaign_id: campaign.id
              }, (function (param) {
                  Curry._1(dispatch, {
                        TAG: /* UpdateSidebarState */6,
                        opened_sidebar: undefined
                      });
                  Curry._1(dispatch, /* RefreshCampaignList */1);
                  Curry._1(setRequestStatus, (function (param) {
                          return {
                                  TAG: /* Live */1,
                                  _0: undefined
                                };
                        }));
                  var campaign_action_message;
                  switch (campaign_action) {
                    case /* Approve */0 :
                        campaign_action_message = "approved";
                        break;
                    case /* Reject */1 :
                        campaign_action_message = "rejected";
                        break;
                    case /* Delete */2 :
                        campaign_action_message = "deleted";
                        break;
                    
                  }
                  return Curry._1(dispatch, {
                              TAG: /* OpenSnackbar */7,
                              snackbar_message: {
                                TAG: /* Success */0,
                                _0: "Campaign " + campaign_action_message + " Successfully"
                              }
                            });
                }), (function (error) {
                  Curry._1(dispatch, {
                        TAG: /* OpenSnackbar */7,
                        snackbar_message: {
                          TAG: /* Error */1,
                          _0: ErrorUtils$Catalyst.resolveError(error)
                        }
                      });
                  return Curry._1(setRequestStatus, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                }), country);
  };
  var deteteCampaignConfirmation = function (param) {
    return Curry._1(dispatch, {
                TAG: /* OpenModal */10,
                modal: {
                  isOpen: true,
                  onCancel: (function (param) {
                      return Curry._1(dispatch, /* CloseModal */3);
                    }),
                  onSubmit: (function (param) {
                      updateCampaign(/* Delete */2);
                      Curry._1(dispatch, /* CloseModal */3);
                      return EventTracker.publishEvent({
                                  category: "Allocation Campaign",
                                  action: "Delete Mandatory Allocation Campaign Success",
                                  label: "Random",
                                  value: undefined,
                                  nonInteraction: undefined
                                });
                    }),
                  title: "Delete Campaign",
                  confirm_button_title: "Yes, Proceed",
                  cancel_button_title: "No, Cancel",
                  modal_body: "You are about to delete this mandatory campaign. Are you sure you wish to continue?"
                }
              });
  };
  var getBaseDetails = function (param) {
    var match = campaign.campaign_status;
    var getStyleClass;
    switch (match) {
      case /* Active */0 :
          getStyleClass = "status ald-active-campaign";
          break;
      case /* Scheduled */1 :
          getStyleClass = "status ald-scheduled-campaign";
          break;
      case /* PendingForReview */2 :
          getStyleClass = "status ald-pending-campaign";
          break;
      
    }
    var data = campaign.creator_info;
    var match$1 = campaign.campaign_status;
    var tmp;
    if (match$1 >= 2) {
      tmp = null;
    } else {
      var data$1 = campaign.approver_info;
      tmp = data$1 !== undefined ? React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "section-row"
                }, React.createElement("p", undefined, "Approved By"), React.createElement("p", undefined, data$1.approved_by.name)), React.createElement("div", {
                  className: "section-row"
                }, React.createElement("p", undefined, "Approved On"), React.createElement("p", undefined, Timestamp$Catalyst.toString(data$1.approved_on, "DD/MM/YYYY HH:mm A")))) : React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "section-row"
                }, React.createElement("p", undefined, "Approved By"), React.createElement("p", undefined, "-")), React.createElement("div", {
                  className: "section-row"
                }, React.createElement("p", undefined, "Approved On"), React.createElement("p", undefined, "-")));
    }
    return React.createElement(React.Fragment, undefined, React.createElement("div", {
                    className: "section-row"
                  }, React.createElement("p", {
                        className: "status"
                      }, "Status"), React.createElement("p", {
                        className: getStyleClass
                      }, FilterAllocationTableTab.toString(campaign.campaign_status))), data !== undefined ? React.createElement(React.Fragment, undefined, React.createElement("div", {
                          className: "section-row"
                        }, React.createElement("p", undefined, "Created By"), React.createElement("p", undefined, data.created_by.name)), React.createElement("div", {
                          className: "section-row"
                        }, React.createElement("p", undefined, "Created On"), React.createElement("p", undefined, Timestamp$Catalyst.toString(data.created_on, "DD/MM/YYYY HH:mm A")))) : React.createElement(React.Fragment, undefined, React.createElement("div", {
                          className: "section-row"
                        }, React.createElement("p", undefined, "Created By"), React.createElement("p", undefined, "N/A")), React.createElement("div", {
                          className: "section-row"
                        }, React.createElement("p", undefined, "Created On"), React.createElement("p", undefined, "N/A"))), tmp);
  };
  var getCampaignTypeAndDateTimeDetails = function (param) {
    var tmp;
    tmp = typeof requestStatus === "number" || requestStatus.TAG !== /* Loading */0 ? null : React.createElement(ProgressModal.make, {
            isOpen: true
          });
    var data = campaign.effective_till;
    var tmp$1;
    if (data !== undefined) {
      var data$1 = Caml_option.valFromOption(data);
      tmp$1 = React.createElement(React.Fragment, undefined, React.createElement("div", {
                className: "section-row"
              }, React.createElement("p", undefined, "End Date ", React.createElement("label", {
                        className: "unit"
                      }, "(DD/MM/YYYY)")), React.createElement("p", undefined, Timestamp$Catalyst.toString(data$1, "DD/MM/YYYY"))), React.createElement("div", {
                className: "section-row"
              }, React.createElement("p", undefined, "End Time ", React.createElement("label", {
                        className: "unit"
                      }, "(HH:MM)")), React.createElement("p", undefined, Timestamp$Catalyst.toString(data$1, "HH:mm"))));
    } else {
      tmp$1 = React.createElement(React.Fragment, undefined, React.createElement("div", {
                className: "section-row"
              }, React.createElement("p", undefined, "End Date (DD/MM/YYYY)"), React.createElement("p", undefined, "N/A")), React.createElement("div", {
                className: "section-row"
              }, React.createElement("p", undefined, "End Time (HH:MM)"), React.createElement("p", undefined, "N/A")));
    }
    return React.createElement(React.Fragment, undefined, React.createElement(React.Fragment, undefined, tmp), React.createElement("div", {
                    className: "section-row"
                  }, React.createElement("p", undefined, "Type"), React.createElement("p", undefined, "Mandatory")), React.createElement("div", {
                    className: "section-row"
                  }, React.createElement("p", undefined, "Start Date ", React.createElement("label", {
                            className: "unit"
                          }, "(DD/MM/YYYY)")), React.createElement("p", undefined, Timestamp$Catalyst.toString(campaign.effective_from, "DD/MM/YYYY"))), React.createElement("div", {
                    className: "section-row"
                  }, React.createElement("p", undefined, "Start Time ", React.createElement("label", {
                            className: "unit"
                          }, "(HH:MM)")), React.createElement("p", undefined, Timestamp$Catalyst.toString(campaign.effective_from, "HH:mm"))), tmp$1);
  };
  var match$2 = campaign.campaign_status;
  var match$3 = campaign.campaign_status;
  var match$4 = campaign.campaign_status;
  var match$5 = campaign.campaign_status;
  var match$6 = campaign.campaign_status;
  var tmp;
  switch (match$6) {
    case /* Active */0 :
        tmp = null;
        break;
    case /* Scheduled */1 :
        var match$7 = user_role.access_level;
        tmp = match$7 !== 0 ? null : React.createElement(AllocationCampaignFooterCmp.make, {
                onLeftBtnClick: (function (param) {
                    return deteteCampaignConfirmation(undefined);
                  }),
                leftBtnText: "Delete",
                onRightBtnClick: (function (param) {
                    
                  }),
                rightBtnText: ""
              });
        break;
    case /* PendingForReview */2 :
        var match$8 = user_role.access_level;
        tmp = match$8 !== 1 ? (
            match$8 !== 0 ? null : React.createElement(AllocationCampaignFooterCmp.make, {
                    onLeftBtnClick: (function (param) {
                        return Curry._1(dispatch, {
                                    TAG: /* OpenModal */10,
                                    modal: {
                                      isOpen: true,
                                      onCancel: (function (param) {
                                          return Curry._1(dispatch, /* CloseModal */3);
                                        }),
                                      onSubmit: (function (param) {
                                          updateCampaign(/* Reject */1);
                                          Curry._1(dispatch, /* CloseModal */3);
                                          return EventTracker.publishEvent({
                                                      category: "Allocation Campaign",
                                                      action: "Reject Mandatory Allocation Campaign Success",
                                                      label: "Random",
                                                      value: undefined,
                                                      nonInteraction: undefined
                                                    });
                                        }),
                                      title: "Reject Campaign",
                                      confirm_button_title: "Yes, Proceed",
                                      cancel_button_title: "No, Cancel",
                                      modal_body: "You are about to reject a new mandatory campaign. Are you sure you wish to continue?"
                                    }
                                  });
                      }),
                    leftBtnText: "Reject",
                    onRightBtnClick: (function (param) {
                        return Curry._1(dispatch, {
                                    TAG: /* OpenModal */10,
                                    modal: {
                                      isOpen: true,
                                      onCancel: (function (param) {
                                          return Curry._1(dispatch, /* CloseModal */3);
                                        }),
                                      onSubmit: (function (param) {
                                          updateCampaign(/* Approve */0);
                                          return Curry._1(dispatch, /* CloseModal */3);
                                        }),
                                      title: "Approve Campaign",
                                      confirm_button_title: "Yes, Proceed",
                                      cancel_button_title: "No, Cancel",
                                      modal_body: "You are about to approve a new mandatory campaign. Are you sure you wish to continue?"
                                    }
                                  });
                      }),
                    rightBtnText: "Approve"
                  })
          ) : React.createElement(AllocationCampaignFooterCmp.make, {
                onLeftBtnClick: (function (param) {
                    return deteteCampaignConfirmation(undefined);
                  }),
                leftBtnText: "Delete",
                onRightBtnClick: (function (param) {
                    
                  }),
                rightBtnText: ""
              });
        break;
    
  }
  return React.createElement("div", {
              className: "ald-view-campaign-details-sidebar-container"
            }, React.createElement(SidebarHeaderCmp.make, {
                  preview: false,
                  campaign_name: campaign.name,
                  discard_warning_required: false,
                  dispatch: dispatch
                }), React.createElement("div", {
                  className: "campaign-details-body"
                }, React.createElement("div", {
                      className: "ald-exisitng-campaigns-details"
                    }, match$2 >= 2 ? React.createElement(MandatoryAllocationCampaignsCmp.make, {
                            filtered_campaings: campaigns_list.campaigns
                          }) : null), React.createElement("div", {
                      className: "ald-preview-campaign-detail-wrapper"
                    }, React.createElement("div", {
                          className: "ald-preview-campaign-detail"
                        }, React.createElement("div", undefined, React.createElement(CityVehicleCmp.make, {
                                  vehicle_name: campaign.vehicle.vehicle.display_name,
                                  geo_region: campaign.geo_region.name
                                }), React.createElement("div", {
                                  className: "section"
                                }, getBaseDetails(undefined)), React.createElement("div", {
                                  className: "section"
                                }, getCampaignTypeAndDateTimeDetails(undefined)), React.createElement("div", {
                                  className: "section ald-filter-section"
                                }, React.createElement("div", {
                                      className: "filter"
                                    }, React.createElement(AllocationFilterWrapper.make, {
                                          filter_data: {
                                            TAG: /* AllocationRadius */0,
                                            filter_value: {
                                              left_value: campaign.filters.allocation_radius.auto,
                                              right_value: campaign.filters.allocation_radius.manual
                                            },
                                            delta_value: match$3 !== 0 ? ({
                                                  left_value: campaign.filters.allocation_radius.auto - active_campaign.filters.allocation_radius.auto,
                                                  right_value: campaign.filters.allocation_radius.manual - active_campaign.filters.allocation_radius.manual
                                                }) : undefined
                                          },
                                          show_header: true
                                        })), React.createElement("div", {
                                      className: "filter"
                                    }, React.createElement(AllocationFilterWrapper.make, {
                                          filter_data: {
                                            TAG: /* DryRun */1,
                                            filter_value: {
                                              left_value: campaign.filters.dry_run.threshold,
                                              right_value: campaign.filters.dry_run.ratio
                                            },
                                            delta_value: match$4 !== 0 ? ({
                                                  left_value: campaign.filters.dry_run.threshold - active_campaign.filters.dry_run.threshold,
                                                  right_value: campaign.filters.dry_run.ratio - active_campaign.filters.dry_run.ratio
                                                }) : undefined
                                          },
                                          show_header: true
                                        })), React.createElement("div", {
                                      className: "filter"
                                    }, React.createElement(AllocationFilterWrapper.make, {
                                          filter_data: {
                                            TAG: /* MaxDryRun */2,
                                            filter_value: {
                                              left_value: campaign.filters.maps_distance.auto,
                                              right_value: campaign.filters.maps_distance.manual
                                            },
                                            delta_value: match$5 !== 0 ? ({
                                                  left_value: campaign.filters.maps_distance.auto - active_campaign.filters.maps_distance.auto,
                                                  right_value: campaign.filters.maps_distance.manual - active_campaign.filters.maps_distance.manual
                                                }) : undefined
                                          },
                                          show_header: true
                                        }))))))), tmp);
}

var make = ViewCampaign;

export {
  make ,
  
}
/* react Not a pure module */
